import React, { useEffect, useMemo, useState } from 'react'
import { Html, Line } from '@react-three/drei'
import { params } from '../../../../../../redux/reducers/reducer';

const OutLineSection = () => {

    const offsetCB = 0.2;
    const offsetHor = 0.15;
    const offsetVer = 0.2;
    const railWidth = 0.2;

    const offset = useMemo(() => {
        if(params.frontLeanStoragePosition > 0 && params.frontLeanStoragePosition !== params.leanF_p_d - parseInt(params.add_storage_front) - 0.2) return railWidth;
        else return 0
    }, [params.frontLeanStoragePosition, params.leanF_p_d, params.add_storage_front])

    const topLinePoints = useMemo(() => (
        [
            [-params.leanF_p_d / 2 , params.leanF_p_h + params.leanF_p_w * params.b_l_t_r_pF / 12 + offsetVer, (params.p_d / 2 + offsetCB)],
            [-params.leanF_p_d / 2 + parseInt(params.add_storage_front) + offset, params.leanF_p_h + params.leanF_p_w * params.b_l_t_r_pF / 12 + offsetVer, params.p_d / 2 + offsetCB],
            [-params.leanF_p_d / 2 + parseInt(params.add_storage_front) + offset, params.leanF_p_h  + offsetHor, params.p_d / 2 + params.leanF_p_w + offsetCB * 2],
            [-params.leanF_p_d / 2 + parseInt(params.add_storage_front) + offset, 0.2, params.p_d / 2 + params.leanF_p_w + offsetCB * 2],
            [-params.leanF_p_d / 2, 0.2, params.p_d / 2 + params.leanF_p_w + offsetCB * 2],
            [-params.leanF_p_d / 2, params.leanF_p_h  + offsetHor, params.p_d / 2 + params.leanF_p_w + offsetCB * 2],
            [-params.leanF_p_d / 2, params.leanF_p_h + params.leanF_p_w * params.b_l_t_r_pF / 12 + offsetVer, params.p_d / 2 + offsetCB * 2],
        ]
    ), [params.leanF_p_d, params.p_d, params.leanF_p_w, params.leanF_p_h, params.b_l_t_r_pF, params.add_storage_front, offset])

    return (
        <>
            <Line
                points={topLinePoints}
                color="#00BE00"
                lineWidth={3}
                dashSize={0.3}
                gapSize={0.1}
                dashed
            />
            <Html occlude position={[(-params.leanF_p_d + parseInt(params.add_storage_front) + offset) / 2, params.leanF_p_h + params.leanF_p_w * params.b_l_t_r_pF / 12 + 0.5 , params.p_d / 2 + 0.5]} style={{ pointerEvents: 'none' }}>
                <span style={{backgroundColor: 'white', border: 'solid 2px #00BE00', color: 'black', borderRadius: '50%', cursor: 'pointer', display:'flex', alignItems: 'center', justifyContent: 'center', padding: '3px', userSelect: 'none', fontSize: 'smaller'}}>
                    <i className='icon-drag-ico'/>
                </span>
            </Html>
        </>
    )
}

export default OutLineSection